import React from 'react';
import { Tooltip } from '@mui/material';

const CustomTooltip = ({
  title,
  children,
  placement = 'top',
  arrow = true,
  ...props
}) => {
  return (
    <Tooltip
      title={title}
      arrow={arrow}
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            padding: 'var(--sp-sm) var(--sp-md2)',
            backgroundColor: '#333',
            color: '#fff',
            borderRadius: 'calc(var(--sp-xxs)*2)',
            maxWidth: 'calc(var(--fs-hero)*8.25471)',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;